import { withChartLayout } from 'components/common';
import DailyPsychosocialAssessment from 'components/features/chart/special-charts/daily-psychosocial-assessment/DailyPsychosocialAssessment';

const DailyPsychosocialAssessmentPage = withChartLayout('Daily Psychosocial Assessment')(DailyPsychosocialAssessment);
export default DailyPsychosocialAssessmentPage;
